export default "__VITE_ASSET__DAOOyzMd__"